import { render, staticRenderFns } from "./mineIndex.vue?vue&type=template&id=68db1cb1&"
import script from "./mineIndex.vue?vue&type=script&lang=js&"
export * from "./mineIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports